import React from "react";
import config from "Config";
import logo from "Assets/img/geografia_logo.svg";
// import backgroundImage from 'Assets/img/dlgcs_brand_element_banner.svg';
import history from "Services/history";
import { Tooltip } from "reactstrap";
import withState from "recompose/withState";

const STATE = config.admin_state_acronym.toLowerCase();
const client_logo_name =
  STATE === "qld" ? "client_logo.svg" : "client_logo.png";
const ClientLogo = require(`Assets/${STATE}/img/${client_logo_name}`);

const addToolTipState = withState("tooltipOpen", "setTooltipOpen", false);
const addToolTipGlossaryState = withState("tooltipGlossaryOpen", "setTooltipGlossaryOpen", false);

const Template = ({ tooltipOpen, setTooltipOpen, tooltipGlossaryOpen, setTooltipGlossaryOpen }) => (
  <div
    id="topmenu"
    className="top-menu-bg white align-items-center justify-content-between"
  >
    <div className="mr-auto client_logo">
      <a
        className=""
        href={config.department_url}
        target="_blank"
        rel="noopener"
      >
        <img src={ClientLogo} />
      </a>
    </div>
    <div className="company_logo ml-auto">
      <a
        className="ml-auto"
        target="_blank"
        rel="noopener"
        href="http://geografia.com.au"
      >
        <img src={logo} />
      </a>

      <Tooltip
        placement="left"
        isOpen={tooltipOpen}
        target="TooltipElemInfo"
        toggle={_ => setTooltipOpen(!tooltipOpen)}
      >
        How to use this site
      </Tooltip>

      <span
        style={{ cursor: "pointer", marginRight: "10px" }}
        id="TooltipElemInfo"
        onClick={_ => history.push("/about")}
        className="fa-stack fa "
      >
        <i className="fa fa-circle-thin fa-stack-2x" />
        <i className="fa fa-info fa-stack-1x" />
      </span>

      <Tooltip
        placement="left"
        isOpen={tooltipGlossaryOpen}
        target="TooltipElemGlossary"
        toggle={_ => setTooltipGlossaryOpen(!tooltipGlossaryOpen)}
      >
        Glossary
      </Tooltip>

      <span
        style={{ cursor: "pointer"}}
        id="TooltipElemGlossary"
        onClick={_ => history.push({
        pathname: "/about",
        hash: "glossary",
        })}
        className="fa-stack fa "
      >
        <i className="fa fa-circle-thin fa-stack-2x" />
        <i className="fa fa-book fa-stack-1x" />
      </span>
    </div>
  </div>
);

export default addToolTipGlossaryState(addToolTipState(Template));


// WEBPACK FOOTER //
// ./components/TopMenu.js